import { get } from 'lodash-es';
import { getMeta } from 'site-modules/shared/utils/seo-helper';
import { getFullImageUrl, MAX_HEIGHT, MAX_WIDTH } from 'client/utils/image-helpers';
import { getWebpageSchema } from 'client/seo/schemas/webpage';
import { getFAQSchema } from 'client/seo/schemas/faq';
import { getQAEntriesFromContent } from 'client/site-modules/shared/utils/faq';
import { getArticleSchema } from 'client/seo/schemas/article';
import { getImageSchema } from 'client/seo/schemas/image';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { buildBreadcrumbs } from 'site-modules/editorial/utils/best';

export function getEntry(content, id) {
  const main = content.child('main');
  const footer = content.child('footer');
  const rightRail = content.child('right-rail');

  if (main.hasChild(id)) {
    return main.child(id);
  }
  if (footer.hasChild(id)) {
    return footer.child(id);
  }
  if (rightRail.hasChild(id)) {
    return rightRail.child(id);
  }

  return content.child(id);
}

export function getBestSeoObject(content, pathname) {
  const meta = getMeta(content);
  const title = meta.title || `${content.title} | Edmunds`;

  const heroImage = content.metadata('promoImage').value(get(getEntry(content, 'hero-content').links()[0]));
  const heroImageUrl = getFullImageUrl(heroImage, MAX_WIDTH);
  const image = heroImage && {
    url: heroImageUrl,
    uri: heroImageUrl,
    width: MAX_WIDTH,
    height: MAX_HEIGHT,
  };

  return {
    ...meta,
    title,
    image,
    jsonld: [
      getWebpageSchema(title),
      getBreadcrumbSchema(buildBreadcrumbs(content.child('config'), content.title, pathname)),
      getFAQSchema({
        entries: getQAEntriesFromContent(getEntry(content, 'faq')),
        canonical: meta.canonical,
        generateLearnMoreLinks: true,
      }),
      getArticleSchema({
        articleObject: content,
        image: heroImage && getImageSchema(image),
        author: getEntry(content, 'author').child('author-info').metadata('authorName').value(),
      }),
    ],
  };
}
